import type { CropVarietyConfigurationsByKey } from "../types.js";

export const loganberryVarietyConfigurations = {
    "loganberry.logan": { crop: "loganberry", aliases: ["Loganberry"], isExample: false, customName: false },
    "loganberry.thornless-logan": {
        crop: "loganberry",
        aliases: ["Thornless Loganberry"],
        isExample: false,
        customName: false,
    },
    "loganberry.custom": { crop: "loganberry", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
